import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'empAdvance/'

const initialState = {
    advancesList: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const getAdvances = createAsyncThunk('empAdv/ga', async (_, thunkAPI) => {
    try {
        const result = await axios.get(API_URL)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getSingleAdvance = createAsyncThunk('empAdv/ga', async (advID, thunkAPI) => {
    try {
        const result = await axios.get(`${API_URL}${advID}`)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const addAdvance = createAsyncThunk('empAdv/aa', async (advData, thunkAPI) => {
    try {
        const result = await axios.post(`${API_URL}`, advData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const editAdvance = createAsyncThunk('empAdv/ea', async (advData, thunkAPI) => {
    try {

        const result = await axios.put(`${API_URL}${advData.advID}`, advData.payload)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const deleteAdvance = createAsyncThunk('empAdv/da', async (advID, thunkAPI) => {
    try {

        const result = await axios.delete(`${API_URL}${advID}`)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const empAdvanceSlice = createSlice({
    name: 'sal',
    initialState,
    reducers: {
        reset: (state) => {
            state.advancesList = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(getAdvances.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getAdvances.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.advancesList = action.payload
            })
            .addCase(getAdvances.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
                state.advancesList = []
            })
            .addCase(addAdvance.pending, (state) => {
                state.isLoading = true
            })
            .addCase(addAdvance.fulfilled, (state, action) => {
                state.isLoading = false
            })
            .addCase(editAdvance.pending, (state) => {
                state.isLoading = true
            })
            .addCase(editAdvance.fulfilled, (state, action) => {
                state.isLoading = false
            })
            .addCase(deleteAdvance.pending, (state) => {
                state.isLoading = true
            })
            .addCase(deleteAdvance.fulfilled, (state, action) => {
                state.isLoading = false
            })
    }
})

export const { reset } = empAdvanceSlice.actions

export default empAdvanceSlice.reducer
